import { FC, useEffect, useState } from 'react';
import { Tabs, Typography } from 'antd';
import { TbFocusCentered } from 'react-icons/tb';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

import Metadata from './meta';
import Overview from './routes/01-Overview';
import Preferences from './routes/02-Preferences';

// interface GeneralProps {}

const General: FC = (): JSX.Element => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, []);

    const { token } = useAntDesignTheme();

    const url = '/settings/workspace/general';

    const items = [
        {
            label: (
                <>
                    <TbFocusCentered size='1rem' style={{ verticalAlign: '-0.175rem', marginRight: '0.375rem' }} />
                    Overview
                </>
            ),
            key: 'overview',
            children: <Overview />,
        },
        {
            label: (
                <>
                    <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='1rem'
                        height='1rem'
                        style={{ verticalAlign: '-0.175rem', marginRight: '0.375rem' }}
                        viewBox='0 0 24 24'
                        fill='none'
                        stroke='currentColor'
                        strokeWidth='2'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        className='icon icon-tabler icons-tabler-outline icon-tabler-blocks'
                    >
                        <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                        <path d='M14 4a1 1 0 0 1 1 -1h5a1 1 0 0 1 1 1v5a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1z' />
                        <path d='M3 14h12a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h3a2 2 0 0 1 2 2v12' />
                    </svg>
                    Preferences
                </>
            ),
            key: 'preferences',
            children: <Preferences />,
        },
    ];

    const activeKey = location.pathname.split('/')[4];

    const navigate = useNavigate();

    const onChangeTab = (newActiveKey: string) => {
        navigate(`${url}/${newActiveKey}`);
    };

    return (
        <>
            <Metadata />

            <Typography.Title level={1}>General</Typography.Title>
            <Typography.Paragraph style={{ color: token.colorTextTertiary }}>
                See and update your workspace information here.
            </Typography.Paragraph>
            <Routes>
                <Route index element={<Navigate to={`${url}/overview`} replace />} />
                <Route
                    path='*'
                    element={<Tabs items={items} animated={true} activeKey={activeKey} size='small' onChange={onChangeTab} />}
                />
            </Routes>
        </>
    );
};

export default General;
